import moment from 'moment'
import type { Store } from 'redux'

import config from 'config/auth'
import { authorise } from 'utils/clientAuthorise'

let timeOutRef: ReturnType<typeof setTimeout>

export async function clientAuthorise(store: Store) {
  return authorise(store)
}

async function refreshClient(store: Store) {
  const hasRefreshCookie = store.getState().auth.get('hasRefreshCookie')

  try {
    if (hasRefreshCookie) {
      await clientAuthorise(store)
    }
  } catch (err) {
    // refresh failed
  }

  if (hasRefreshCookie) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    refresh(store)
  }
}

export function refresh(store: Store) {
  try {
    const expiresAt = store.getState().auth.get('expiresAt')
    if (expiresAt) {
      const now = moment()
      const refreshAt = moment(expiresAt).subtract(config.expiresThreshold, 'minutes')
      const ttl = Math.max(1, Math.round(moment.duration(refreshAt.diff(now)).asSeconds()))

      clearTimeout(timeOutRef)
      timeOutRef = setTimeout(() => {
        refreshClient(store)
      }, ttl * 1000)
    }
  } catch (err) {
    // refresh failed
    clearTimeout(timeOutRef)
  }
}
